module.exports = new __parcel__URL__("solar-power.b54c23ac.jpg").toString();